import { useEffect, useState, useRef } from "react";
import { Button } from "../components/ui/button";
import {
  Loader2,
} from "lucide-react";

import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { shopifyBackendBaseUrl } from "../admin/dashboards/urls";
import { useAuth } from "wasp/client/auth";
import { useTranslation, TranslationKey } from "../i18n/hooks";

type ShopifyConnectionViewProps = {
};

export default function ShopifyReconnectView({

}: ShopifyConnectionViewProps) {
  const { t } = useTranslation();
  const [isConfirming, setIsConfirming] = useState(false);
  const formref = useRef<HTMLFormElement>(null);
  const {data: user} = useAuth();
  const {currentCollection} = useSelector((state: RootState) => state.user);

  return (
    <form
      id="install-app-form"
      action={`${shopifyBackendBaseUrl}/authorize`}
      method="GET"
      ref={formref}
    >
      <div>
        {t('reconnectDialog.reconnect_description')}
      </div>
      <div>
        <div className="space-y-6">
          {/* Hidden store inputs */}
          <input
            type="hidden"
            name="redirectPath"
            value={window.location.href}
          />
          <input
            type="hidden"
            id="shop"
            name="shop"
            value={currentCollection?.collection?.miqShopifyDomain ?? ""}
          />

          {/* OAuth Section */}

          {currentCollection?.collection?.miqShopifyDomain && (
            <div className="mt-4 space-y-4">
              <div className="bg-gray-50 dark:bg-gray-900 p-4 rounded-md border border-gray-200 dark:border-gray-700">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                  {t('reconnectDialog.store_name' as any as TranslationKey)}
                </label>
                <input
                  type="text"
                  value={currentCollection?.collection?.miqShopifyDomain}
                  disabled
                  className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md text-gray-700 dark:text-gray-300 disabled:bg-gray-50 disabled:dark:bg-gray-800 disabled:text-gray-600 disabled:dark:text-gray-400 disabled:cursor-not-allowed focus:ring-1 focus:ring-black dark:focus:ring-gray-400"
                />
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  {t('reconnectDialog.your_store_url' as any as TranslationKey)}{" " + currentCollection?.collection?.miqShopifyDomain}
                
                </p>
              </div>


                <Button
                  disabled={isConfirming}
                  className="w-full"
                  variant="default"
                 onClick={() => {
                  setIsConfirming(true);
                  formref.current?.submit();
                 }}
                >
                  {isConfirming && (
                    <Loader2 className="w-4 h-4 animate-spin mr-2" />
                  )}
                  {t('reconnectDialog.reconnect_shopify' as any as TranslationKey)}
                </Button>
            </div>
          )}

        </div>
      </div>
    </form>
  );
}
